import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

import { Observable, from, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

import { HttpConstants } from '../models/http.constants';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  private cacheStorage: Storage | null = null;

  constructor(private storage: Storage) {
    this.init();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    if (req.method !== 'GET') {
      return next.handle(req);
    }

    if (!req.headers.has(HttpConstants.CacheIntercept)) {
      return next.handle(req);
    }

    const cacheKey = req.headers.get(HttpConstants.CacheIntercept);
    return from(this.cacheStorage.get(cacheKey)).pipe(
      switchMap((cachedItem) => {
        if (cachedItem) {
          return of(new HttpResponse({ body: cachedItem, status: 200 }));
        } else {
          return next.handle(req).pipe(
            tap((res) => {
              if (res instanceof HttpResponse && res.ok) {
                this.cacheStorage.set(cacheKey, res.body);
              }
            })
          );
        }
      })
    );
  }

  private async init(): Promise<void> {
    const storage = await this.storage.create();
    this.cacheStorage = storage;
  }
}
